import { IAllRegistrationData, IWalletPersonalData } from '@/types/types';

export const getRegDataOrNonMemberPersonalData =
    (
        registrationData: Partial<IAllRegistrationData> | undefined,
        nonMemberPersonalData?: Partial<IWalletPersonalData> | undefined,
    ) =>
    (
        regField: keyof IAllRegistrationData,
        walletField?: keyof IWalletPersonalData,
    ): string | undefined => {
        if (registrationData && registrationData[regField]) {
            return String(registrationData[regField]);
        } else if (nonMemberPersonalData) {
            if (walletField && nonMemberPersonalData[walletField]) {
                return String(nonMemberPersonalData[walletField]);
            } else if (nonMemberPersonalData[regField as keyof IWalletPersonalData]) {
                return String(nonMemberPersonalData[regField as keyof IWalletPersonalData]);
            }
        } else {
            return '';
        }
    };
